import { useEffect, useState } from 'react';
import type { ProductProps } from 'tsconfig/types';
import useProductData from '../../../../hooks/useProductData';

export const useUpsellProduct = (upsellProductCode: string) => {
  const [upsellProduct, setUpsellProduct] = useState<ProductProps | null>(null);
  const { product: upsellData } = useProductData(upsellProductCode);

  useEffect(() => {
    if (upsellData && !upsellProduct) {
      setUpsellProduct(upsellData);
    }
  }, [upsellData, upsellProduct]);

  return upsellProduct;
};
